namespace Areas.Employee.CreateEmployee {
    "use strict";

    export function createEmployee() {
        const form = $("#CreateEmployeeForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const newData: any = form.option("formData");
            sendRequest('/Employee/CreateEmployee/Post', JSON.stringify(newData), "POST");
        }
    }
}